module.exports = __webpack_public_path__ + "img/logo2.b34ae52f.svg";